// @vendors
const Immutable = require('immutable');
// @constants
const actionTypes = require('constants/actionTypes');
// @utilities

function setInitialState() {
    return Immutable.fromJS({});
}

const initMBTranslations = (state = setInitialState(), action) => {
  switch (action.type) {
    case actionTypes.INIT_MB_TRANSLATIONS_REQUEST:
      return state.merge({
        isFetching: true,
        successfully: false,
        hasError: false,
        error: '',
      });
    case actionTypes.INIT_MB_TRANSLATIONS_SUCCESS:
      return state.merge(
        {
          isFetching: false,
          hasBeenFetched: true,
          error: '',
        },
        action.payload.translations
      );
    case actionTypes.INIT_MB_TRANSLATIONS_ERROR:
      return state.merge({
        isFetching: false,
        hasError: true,
        error: action.payload.error,
      });
    default:
      return state;
  }
};

module.exports = initMBTranslations;
